export function setScrollBehaviorAuto() {
    document.documentElement.style.scrollBehavior = "auto";
}

export function restoreScrollBehavior() {
    document.documentElement.removeAttribute("style");
}